module.exports = __webpack_public_path__ + "static/img/mobile_app_2.4af1f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/trade/img/mobile_app_2.jpg
// module id = X2Qv
// module chunks = 1